/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InsuredInfo
 */
export interface InsuredInfo {
    /**
     * 
     * @type {string}
     * @memberof InsuredInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredInfo
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof InsuredInfo
     */
    email: string;
}

/**
 * Check if a given object implements the InsuredInfo interface.
 */
export function instanceOfInsuredInfo(value: object): value is InsuredInfo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function InsuredInfoFromJSON(json: any): InsuredInfo {
    return InsuredInfoFromJSONTyped(json, false);
}

export function InsuredInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InsuredInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'email': json['email'],
    };
}

export function InsuredInfoToJSON(json: any): InsuredInfo {
    return InsuredInfoToJSONTyped(json, false);
}

export function InsuredInfoToJSONTyped(value?: InsuredInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'label': value['label'],
        'email': value['email'],
    };
}

